interface FigmaCTAProps {
  handleClick: () => void;
}

export function FigmaCTA({ handleClick }: FigmaCTAProps) {
  return (
    <section className="bg-[#f2f2f2] py-[32px] md:py-[48px]">
      <div className="container mx-auto px-4 max-w-[1560px] text-center">
        <h2 className="text-[#101828] text-[24px] md:text-[30px] font-bold leading-[30px] md:leading-[36px] mb-3">
          Contrata ahora tu seguro
        </h2>
        <p className="text-[#4a5565] text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] mb-6">
          Circula protegido desde el primer día
        </p>
        <button
          onClick={handleClick}
          className="bg-[#ff6900] hover:bg-[#e05f00] text-white px-6 md:px-8 h-[44px] md:h-[48px] rounded-[6px] font-bold text-[14px] md:text-[16px] leading-[20px] transition-colors"
        >
          Contratar ahora
        </button>
        <p className="text-[#4a5565] text-[12px] leading-[18px] mt-8">
          Seguro para mayores de 18 años *Contratación sujeta a normas de
          suscripción de la compañía.
        </p>
      </div>
    </section>
  );
}
